(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 7801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(1864);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BlogVertical; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5005);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Badge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7977);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_shared_functions_dateFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9847);
/* harmony import */ var _BlogVertical_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3013);
/* harmony import */ var _BlogVertical_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_BlogVertical_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable jsx-a11y/alt-text */ /* eslint-disable react/no-danger-with-children */ 






function BlogVertical(param) {
    let { imageUrl , title , halfTitle , subtitle , datePublished , footer , customClass , col1 , col2 , colLg1 , colLg2 , colXl1 , colXl2 , linkButton  } = param;
    const newLocal = subtitle !== null && subtitle !== void 0 ? subtitle : "";
    const componentClass = "BlogVertical ".concat((_BlogVertical_module_scss__WEBPACK_IMPORTED_MODULE_3___default().BlogVertical), " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const formattedDate = (0,src_shared_functions_dateFormat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(datePublished ? datePublished : "");
    function BtnLink(param) {
        let { label , link , variant , external  } = param;
        const isExternal = external !== null && external !== void 0 ? external : false;
        if (isExternal) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                href: link,
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: variant,
                    className: "btnBlogVertical",
                    children: label
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: variant,
                className: "btnBlogVertical",
                children: label
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: componentClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "featuredImage",
                    md: col1 ? col1 : 6,
                    lg: colLg1 ? colLg1 : 6,
                    xl: colXl1 ? colXl1 : 6,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: "w-100 position-relative",
                        src: imageUrl,
                        alt: "Casper Labs",
                        fill: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "featuredContent position-relative overflow-hidden d-flex flex-column justify-content-center",
                    md: col2 ? col2 : 6,
                    lg: colLg2 ? colLg2 : 6,
                    xl: colXl2 ? colXl2 : 6,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "half-title",
                            children: halfTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "h4 mb-4",
                            children: title
                        }),
                        datePublished && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "date",
                            children: formattedDate
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: newLocal
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "d-flex btnListMobile ".concat((_BlogVertical_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btnListMobile)),
                            children: linkButton && linkButton.map((p, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BtnLink, {
                                    label: p.label,
                                    link: p.link,
                                    variant: p.variant,
                                    external: p.external
                                }, index))
                        }),
                        footer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Badge__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            bg: "secondary",
                            children: footer
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 9394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentFullScreen2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5005);
/* harmony import */ var _ContentFullScreen2_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(856);
/* harmony import */ var _ContentFullScreen2_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ContentFullScreen2_module_scss__WEBPACK_IMPORTED_MODULE_1__);



function ContentFullScreen2(param) {
    let { halfTitle , title , desc , linkButton , customClass , bgImage , children  } = param;
    const componentClass = "ContentFullScreen2 ".concat((_ContentFullScreen2_module_scss__WEBPACK_IMPORTED_MODULE_1___default().ContentFullScreen2), " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundImage: 'url("'.concat(bgImage, '")')
        },
        className: componentClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "align-items-center ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            lg: 6,
                            children: [
                                halfTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "half-title",
                                    children: "A blockchain for the “other” 25M developers"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "section-title-h2 mb-4",
                                    children: title
                                }),
                                desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: desc
                                }),
                                linkButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    href: linkButton.link,
                                    variant: linkButton.variant,
                                    children: linkButton.label
                                }),
                                children
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            lg: 6
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 9691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5005);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(658);
/* harmony import */ var _ContentRight_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4334);
/* harmony import */ var _ContentRight_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentRight_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function ContentRight(param) {
    let { halfTitle , title , desc , linkButton , linkButton2 , customClass , col1 , col2 , colLg1 , colLg2 , colXl1 , colXl2 , ContentRightContent  } = param;
    const componentClass = "ContentRight ".concat((_ContentRight_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ContentRight), " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: "align-items-center g-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                md: col1,
                                lg: colLg1,
                                xl: colXl1,
                                children: [
                                    halfTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "half-title",
                                        children: "A blockchain for the “other” 25M developers"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "section-title-h2 mb-4",
                                        children: title
                                    }),
                                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: desc
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                        className: "w-100 my-4"
                                    }),
                                    typeof linkButton.link === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: linkButton.link,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: linkButton2 && "me-3 mb-3 mb-lg-0",
                                            variant: linkButton.variant,
                                            children: linkButton.label
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        onClick: ()=>{
                                            linkButton.link();
                                        },
                                        className: linkButton2 && "me-3 mb-3 mb-lg-0",
                                        variant: linkButton.variant,
                                        children: linkButton.label
                                    }),
                                    linkButton2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: linkButton2.link,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            variant: linkButton2.variant,
                                            children: linkButton2.label
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                md: col2,
                                lg: colLg2,
                                xl: colXl2,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "position-relative contentRightContent",
                                    children: ContentRightContent
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 7553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BadgeList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7977);


function BadgeList(param) {
    let { list , onClick , customClass , activeItem , hideAll  } = param;
    const componentClass = "BadgeList ".concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const handleCategoryClick = (id)=>{
        onClick(id);
    };
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: componentClass,
        children: [
            (ref = !hideAll) !== null && ref !== void 0 ? ref : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: "cursor-pointer ".concat(!activeItem ? "active" : ""),
                bg: "secondary",
                onClick: ()=>handleCategoryClick(""),
                children: "All"
            }),
            list && list.map((p)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    className: "cursor-pointer ".concat(activeItem === p.slug ? "active" : ""),
                    bg: "secondary",
                    onClick: ()=>handleCategoryClick(p._id),
                    children: p.value
                }, p._id))
        ]
    });
}


/***/ }),

/***/ 1951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* reexport safe */ _BadgeList_BadgeList__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _BadgeList_BadgeList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7553);




/***/ }),

/***/ 1864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./src/@shared/service/cms-api.ts + 1 modules
var cms_api = __webpack_require__(7746);
;// CONCATENATED MODULE: ./src/@shared/hooks/useInfiniteScroll.ts

function useInfiniteScroll(queryKey, queryFn, slug, initialPage) {
    var ref;
    const result = (0,es.useInfiniteQuery)(queryKey, (param)=>{
        let { pageParam =initialPage !== null && initialPage !== void 0 ? initialPage : 1  } = param;
        return queryFn(pageParam, slug);
    }, {
        getNextPageParam: (lastPage)=>{
            if (!lastPage.pages.hasNext) return false;
            return lastPage.pages.next;
        }
    });
    var ref1;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: Unreachable code error
    const list = (ref1 = (ref = result.data) === null || ref === void 0 ? void 0 : ref.pages.reduce((prev, page)=>prev.concat(page.data), [])) !== null && ref1 !== void 0 ? ref1 : [];
    return {
        ...result,
        list
    };
}

;// CONCATENATED MODULE: ./src/modules/blog/hooks/useBlogList.ts



function useBlogList(initialCatArgs, search, category) {
    const { data: categories  } = (0,es.useQuery)([
        "categories"
    ], ()=>(0,cms_api/* getCategoriesBySlug */.Um)(initialCatArgs));
    const getMore = async (pageParam, slug)=>{
        const args = {
            sort: "position",
            limit: 15,
            page: pageParam,
            slug,
            state: "published"
        };
        return await (0,cms_api/* getPosts */.Jq)(args, categories !== null && categories !== void 0 ? categories : []);
    };
    const { list , isLoading , hasNextPage , fetchNextPage  } = useInfiniteScroll([
        "posts",
        search !== null && search !== void 0 ? search : "",
        category !== null && category !== void 0 ? category : ""
    ], getMore, category);
    const blogList = list;
    return {
        blogList,
        isLoading,
        hasNextPage,
        fetchNextPage
    };
}

;// CONCATENATED MODULE: ./src/modules/blog/hooks/useBlogPage.ts




const reducer = (currentState, newState)=>{
    return {
        ...currentState,
        ...newState
    };
};
function useBlogPage(initialCatArgs) {
    const { data: categories  } = (0,es.useQuery)([
        "categories"
    ], ()=>(0,cms_api/* getCategoriesBySlug */.Um)(initialCatArgs));
    const categoryList = categories;
    const catList = categoryList.map((category)=>{
        var ref;
        return {
            value: category.name,
            _id: category._id,
            slug: (ref = category.meta) === null || ref === void 0 ? void 0 : ref.slug
        };
    });
    const initialState = {
        search: "",
        category: ""
    };
    const [{ search , category  }, setState] = (0,react.useReducer)(reducer, initialState);
    const { blogList , isLoading , hasNextPage , fetchNextPage  } = useBlogList(initialCatArgs, search, category);
    const featured = blogList[0];
    const handleBadgeListClick = (item)=>{
        var ref, ref1;
        var ref2;
        setState({
            category: (ref2 = (ref = categories === null || categories === void 0 ? void 0 : categories.find((categoryItem)=>categoryItem._id === item)) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.slug) !== null && ref2 !== void 0 ? ref2 : ""
        });
    };
    const handleSearchChange = (search)=>{
        setState({
            search
        });
    };
    return {
        search,
        catList,
        category,
        featured,
        blogList,
        isLoading,
        hasNextPage,
        fetchNextPage,
        handleBadgeListClick,
        handleSearchChange
    };
}

;// CONCATENATED MODULE: ./src/assets/img/blog-hero.webp
/* harmony default export */ var blog_hero = ({"src":"/_next/static/media/blog-hero.aba3f824.webp","height":1112,"width":2880,"blurDataURL":"data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAADQAQCdASoIAAMAAkA4JZgCdAEO/gOOAAD++5S+NwNMP7zF3L/s7x9jLW9u5+ylEykOLB/d+VJf57hzjLoAAA==","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Image.js
var Image = __webpack_require__(1330);
;// CONCATENATED MODULE: ./src/assets/img/first-blockchain.webp
/* harmony default export */ var first_blockchain = ({"src":"/_next/static/media/first-blockchain.be391261.webp","height":599,"width":590,"blurDataURL":"data:image/webp;base64,UklGRt4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAABYBPZtpo7z8VvU5EHFpeJiUw6BhHsh/naiIgQaPOkQQQN2UJgbPwPC4j5vkxgL/x/bkFKfh9ZqPAlv0gBejeYAABWUDggdgAAAJACAJ0BKggACAACQDglsAJ0ugCGVfYdBaN7he0AAP5m3t0j679Cx55aC05eLOnQCoTPLS/PpvH1F6Pfc7CBttleJK1Tk8NOD/FxWz9VG++x/wcmbN/4DrfiT/Hl/Z6P/lfe8Rw3yxj/0KJr/xhxfT8a/yqAAAA=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(5005);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/img/business-speed.webp
/* harmony default export */ var business_speed = ({"src":"/_next/static/media/business-speed.48bb1900.webp","height":1434,"width":1470,"blurDataURL":"data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAAAQAgCdASoIAAgAAkA4JbACdLoAArr/fqvgAP77few1QO+1KCyMeMMhqNkta2CTJ/8c5SzISTWBPCP/JlFdB/8FmOON+wd7rLqAAAAA","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/modules/blog/components/BusinessSpeed/BusinessSpeed.module.scss
var BusinessSpeed_module = __webpack_require__(7725);
var BusinessSpeed_module_default = /*#__PURE__*/__webpack_require__.n(BusinessSpeed_module);
;// CONCATENATED MODULE: ./src/modules/blog/components/BusinessSpeed/BusinessSpeed.tsx
/* eslint-disable jsx-a11y/alt-text */ /* eslint-disable react/no-danger-with-children */ 





function BusinessSpeed(param) {
    let { customClass  } = param;
    const componentClass = "BusinessSpeed ".concat((BusinessSpeed_module_default()).BusinessSpeed, " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: componentClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    className: "featuredImage",
                    lg: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "w-100 h-auto",
                        src: business_speed.src,
                        alt: "Casper Labs",
                        width: 800,
                        height: 800
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    className: "featuredContent position-relative overflow-hidden d-flex flex-column justify-content-center",
                    lg: 6,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "mb-4",
                            children: [
                                "Business at the ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-purple",
                                    children: "speed"
                                }),
                                " of market"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-5",
                            children: "Casper Labs is the team behind the development of the Casper Network. It provides services and support for organizations of all sizes, from enterprise to startup. Guided by open source principles, Casper Labs is committed to supporting the next wave of blockchain adoption among businesses and providing developers with a reliable and secure solution."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            "aria-label": "Read more",
                            href: "/professional-services",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "secondary",
                                children: "Read more"
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/@shared/components/ui/index.tsx
var ui = __webpack_require__(1951);
// EXTERNAL MODULE: ./src/@shared/components/head/customHead/customHead.tsx
var customHead = __webpack_require__(3065);
// EXTERNAL MODULE: ./src/@shared/components/content/ContentFullScreen2/ContentFullScreen2.tsx
var ContentFullScreen2 = __webpack_require__(9394);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx + 1 modules
var Newsletter2 = __webpack_require__(7654);
// EXTERNAL MODULE: ./src/@shared/components/blog/BlogVertical/BlogVertical.tsx
var BlogVertical = __webpack_require__(2926);
// EXTERNAL MODULE: ./src/@shared/components/blog/BlogHorizontal/BlogHorizontal.tsx
var BlogHorizontal = __webpack_require__(2296);
// EXTERNAL MODULE: ./src/@shared/components/content/ContentRight/ContentRight.tsx
var ContentRight = __webpack_require__(9691);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
;// CONCATENATED MODULE: ./src/pages/blog/index.tsx
















const initialCatArgs = {
    sort: "timeCreated",
    limit: 0,
    parent: "Blog"
};
var __N_SSP = true;
function Blog() {
    const seoDesc = 'Stay informed with the latest updates in blockchain technologies through Casper Labs\' "Friendly Blog". Explore articles, trends, & industry developments.';
    const { /*         search, */ catList , category , featured , blogList , isLoading , hasNextPage , fetchNextPage , handleBadgeListClick  } = useBlogPage(initialCatArgs);
    const pageClass = "blogPage overflow-hidden ";
    var _webpThumbnailUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: pageClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customHead/* default */.Z, {
                title: "Casper Blog | News, Insights & Updates | Casper Labs",
                description: seoDesc,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: blog_hero.src,
                    as: "image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                animation: "fadeIn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFullScreen2/* default */.Z, {
                            customClass: "blogHero",
                            bgImage: blog_hero.src,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "header-position",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "mb-4 header-section-title",
                                        children: [
                                            "The Friendly ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-green",
                                                children: "Blog"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        md: 8,
                                        lg: 10,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Stay up to date on the latest announcements and news from Casper Labs, along with the broader Casper ecosystem."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                    y: 400,
                                    children: blogList && blogList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                        className: "pt-lg-7 pb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogVertical/* default */.Z, {
                                            customClass: "featuredBlog",
                                            imageUrl: (_webpThumbnailUrl = featured.webpThumbnailUrl) !== null && _webpThumbnailUrl !== void 0 ? _webpThumbnailUrl : featured.thumbnailUrl,
                                            halfTitle: "Featured Post",
                                            title: featured.title,
                                            datePublished: featured.timePublished,
                                            subtitle: featured.preview,
                                            linkButton: [
                                                {
                                                    label: "Read more",
                                                    link: "/blog/".concat(featured.meta.slug),
                                                    variant: "outline"
                                                }
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                    y: 450,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                        className: "pt-6 pb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter2/* default */.Z, {
                                            col1: 6,
                                            col2: 6,
                                            title: "Sign up for our newsletter!",
                                            desc: "Be the first to hear about major upcoming announcements and partnerships"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                    y: 400,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: "recentPosts pt-7",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "h5",
                                                children: "Recent posts"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                className: "my-5 align-items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    md: 12,
                                                    className: "mb-4 mb-lg-0",
                                                    children: catList && catList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* BadgeList */.k, {
                                                        list: catList,
                                                        activeItem: category,
                                                        onClick: (item)=>handleBadgeListClick(item)
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogHorizontal/* default */.Z, {
                                                list: blogList,
                                                isLoading: isLoading,
                                                hasNextPage: hasNextPage,
                                                fetchNextPage: fetchNextPage,
                                                date: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                            y: 400,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessSpeed, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRight/* default */.Z, {
                            customClass: "py-5 py-lg-5 firstBlockhain",
                            colXl1: 5,
                            colXl2: 7,
                            title: "The First Blockchain Built for Enterprise Adoption",
                            linkButton: {
                                label: "Contact Us",
                                link: "/contact?section=contactForm",
                                variant: "primary"
                            },
                            ContentRightContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "Casper",
                                src: first_blockchain.src
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 3013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnListMobile":"BlogVertical_btnListMobile__FWaCj"};

/***/ }),

/***/ 856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ContentFullScreen2":"ContentFullScreen2_ContentFullScreen2__l8s_K","bgImage":"ContentFullScreen2_bgImage__6NYgU"};

/***/ }),

/***/ 4334:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ContentFullScreen2":"ContentRight_ContentFullScreen2__RaASE","bgImage":"ContentRight_bgImage__IMY_O"};

/***/ }),

/***/ 7725:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);




const defaultProps = {
  bg: 'primary',
  pill: false
};
const Badge = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  bg,
  pill,
  text,
  className,
  as: Component = 'span',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'badge');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
  });
});
Badge.displayName = 'Badge';
Badge.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Badge);

/***/ }),

/***/ 1330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export propTypes */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





const propTypes = {
  /**
   * @default 'img'
   */
  bsPrefix: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),

  /**
   * Sets image as fluid image.
   */
  fluid: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),

  /**
   * Sets image shape as rounded.
   */
  rounded: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),

  /**
   * Sets image shape as circle.
   */
  roundedCircle: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),

  /**
   * Sets image shape as thumbnail.
   */
  thumbnail: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool)
};
const defaultProps = {
  fluid: false,
  rounded: false,
  roundedCircle: false,
  thumbnail: false
};
const Image = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  fluid,
  rounded,
  roundedCircle,
  thumbnail,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'img');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
    // eslint-disable-line jsx-a11y/alt-text
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
  });
});
Image.displayName = 'Image';
Image.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Image);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [437,675,182,726,774,888,179], function() { return __webpack_exec__(7801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);